import { render, staticRenderFns } from "./systemFramework.vue?vue&type=template&id=26a5531f&scoped=true&"
import script from "./systemFramework.vue?vue&type=script&lang=js&"
export * from "./systemFramework.vue?vue&type=script&lang=js&"
import style0 from "./systemFramework.vue?vue&type=style&index=0&id=26a5531f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5531f",
  null
  
)

export default component.exports